export default function createHelpers(config) {
  return {
    history: config.history,
  };
}



// WEBPACK FOOTER //
// src/store/createHelpers.js